import { styled } from '@mui/material';

import { theme } from 'styles';

export const StyledTagLabel = styled('div')`
  padding: 8px 16px 8px 8px;

  background: rgba(0, 155, 242, 0.2);
  border-radius: 20px;
  display: flex;
  align-items: center;
  svg {
    margin-right: 8px;
  }
`;

export const LabelW = styled('div')<{ type?: string }>`
  width: ${({ type }) => (type ? 'unset' : '85%')};
  min-height: 36px;
  overflow: hidden;
  display: flex;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: ${({ type }) => type && '#8282FA'};
  color: ${({ type }) => type && '#000'};
  border-radius: ${({ type }) => type && '8px'};
  padding: ${({ type }) => type && '4px 8px'};
  font-size: ${({ type }) => type && '14px'};
  line-height: ${({ type }) => type && '20px'};

  @media (max-width: 1023px) {
    font-size: ${({ type }) => type && '14px'};
    line-height: ${({ type }) => type && '20px'};
    max-width: ${({ type }) => type && '190px'};
  }
`;

export const IconLabelW = styled('div')`
  display: flex;
  align-items: center;

  @media (max-width: 1023px) {
    svg {
      width: 40px;
      height: 40px;
    }
  }
`;

export const ChipW = styled('div')`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: ${theme.palette.info.light};
  border-radius: 8px;
  padding: 5px 10px 5px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.87);
  white-space: nowrap;
  max-width: 220px;
  overflow: hidden;
  min-height: 36px;
  @media (max-width: 1023px) {
    max-width: 180px;
  }
`;

export const ChipLabel = styled('span')`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ChipDeleteBtn = styled('button')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1;

  &:hover {
    color: rgba(0, 0, 0, 0.87);
  }

  svg {
    width: 12px;
    height: 12px;
    display: block;
  }
`;
